import { connect } from 'react-redux'
import {
  selectIsLeftSidebarCollapsed,
  selectIsInboxBootstrapped,
} from 'selectors/app'
import { selectHasCurrentTicketSearchErrored } from 'selectors/search'

import { selectAgentHasMailboxAccess } from 'selectors/mailboxes_base'
import { doHideLaunchBar } from 'actions/app'
import { selectShowInboxesEmptyPage } from 'selectors/trial_setup'
import { selectPrefersShowTopNav } from 'selectors/app/selectAccountPreferences'
import { selectIsAccountBootstrapped } from 'selectors/app/selectAccount'
import { selectCurrentPayload } from 'selectors/location'
import { selectShouldHideFeaturesAnnoucement } from 'ducks/flags'
import Layout from './view'

const select = state => {
  return {
    hasMailboxAccess: selectAgentHasMailboxAccess(state),
    hasSearchErrored: selectHasCurrentTicketSearchErrored(state),
    isLeftSidebarCollapsed: selectIsLeftSidebarCollapsed(state),
    showEmptyInboxPage: selectShowInboxesEmptyPage(state),
    isInboxBootstrapped: selectIsInboxBootstrapped(state),
    showTopNav: selectPrefersShowTopNav(state),
    isAccountBootstrapped: selectIsAccountBootstrapped(state),
    payload: selectCurrentPayload(state),
    shouldHideAnnouncement: selectShouldHideFeaturesAnnoucement(state),
  }
}

const perform = {
  doHideLaunchBar,
}

export default connect(select, perform)(Layout)
